import { useContext, useEffect, useState } from "react";
import Button from "../../../atoms/button";
import Loading from "../../../atoms/loading";
import { getFrete } from "../../functions";
import ToastContext from "../../../../context/toastProvider";
import { cashnatorFloat } from "../../../utils/functions";

const ShippingStep = ({ productData, deliveryData, setStep, setDeliveryData, setProductData }) => {

    const { badToast } = useContext(ToastContext);

    const [loading, setLoading] = useState(false);
    const [shippingOptions, setShippingOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [error, setError] = useState(false);

    useEffect(() => {
        doGetFrete();
        // eslint-disable-next-line
    }, []);

    const doGetFrete = async () => {
        setLoading(true);
        setError(false);
        const data = await getFrete(deliveryData?.address?.postalCode, productData?.gradingType, productData?.numberOfCards, productData?.priority, productData?.declaredValue * 3 / 100, productData?.declaredValue);
        if (data?.type !== "success") {
            setLoading(false);
            badToast("Erro ao obter dados de frete!");
            setError(true);
            return null;
        }
        setSelectedOption(data?.data.filter(d => d?.service === productData?.shippingService)[0] || null);
        setShippingOptions(data?.data);
        setLoading(false);
    }

    const goBack = () => {
        setStep(2);
    }

    const handleNext = () => {
        if (disableNext) {
            return null;
        }
        setDeliveryData(d => { return { ...d, shipping: selectedOption } });
        setProductData(p => { return { ...p, shippingService: selectedOption?.service, shipping: selectedOption?.price } });
        setStep(4);
    }

    const disableNext = !selectedOption;

    return (
        <div className="relative">
            <p className="mb-1 text-sm text-laranjinha/60">
                Envio para o CEP {deliveryData?.address?.postalCode} — escolha o serviço dos Correios:
            </p>
            {
                productData?.shippingService ?
                    <p className="mb-2 text-xs text-green-400">Opção atual do pedido: {productData?.shippingService}</p>
                    : null
            }
            {
                error ? (
                    <div className="my-4 rounded-lg border border-red-500/40 bg-red-950/30 p-3 text-sm text-red-300">
                        <p>Erro ao obter as opções de frete. Verifique se o endereço selecionado é válido.</p>
                        <button type="button" onClick={doGetFrete} className="mt-1 text-xs text-laranjinha underline hover:text-primary">
                            Tentar de novo
                        </button>
                    </div>
                ) : null
            }
            <div role="radiogroup" aria-label="Opções de frete" className="grid min-h-[90px] grid-cols-1 gap-2 sm:grid-cols-3">
                {
                    shippingOptions?.map((s, i) => {
                        const selected = selectedOption === s;
                        return (
                            <button
                                type="button"
                                role="radio"
                                aria-checked={selected}
                                onClick={() => setSelectedOption(s)}
                                key={i}
                                className={`flex flex-col items-start gap-0.5 rounded-lg border px-3 py-2.5 text-left transition ${
                                    selected ? "border-primary bg-mgs-elevated" : "border-primary/25 bg-mgs-surface/60 hover:border-primary/60"
                                }`}
                            >
                                <span className="flex w-full items-center justify-between">
                                    <span className="text-sm text-laranjinha/70">{s?.service}</span>
                                    <span
                                        aria-hidden="true"
                                        className={`flex h-4 w-4 items-center justify-center rounded-full border ${selected ? "border-primary" : "border-primary/40"}`}
                                    >
                                        {selected ? <span className="h-2 w-2 rounded-full bg-primary"></span> : null}
                                    </span>
                                </span>
                                <span className="text-lg font-bold text-laranjinha">{cashnatorFloat(s?.price)}</span>
                                {s?.deadline ? <span className="text-xs text-laranjinha/50">{s.deadline} dias úteis</span> : null}
                            </button>
                        );
                    })
                }
            </div>
            <div className="m-auto mt-5 flex w-fit gap-3">
                <Button click={goBack} classes="bg-purple-400 hover:bg-purple-300 px-4">← Voltar</Button>
                <Button click={handleNext} classes="bg-green-400 hover:bg-green-300 px-6" disabled={disableNext}>Avançar →</Button>
            </div>
            {/* LOADING OVERLAY */}
            {
                loading ?
                    <div className="absolute top-0 left-0 w-full h-full bg-[#000000dd] flex justify-center items-center">
                        <Loading />
                    </div>
                    : null
            }
        </div>
    )
}

export default ShippingStep;
